import React from 'react';
import { motion } from 'framer-motion';
import { Download, Clock, Infinity } from 'lucide-react';
export function PricingSection() {
  return <section id="comprar" className="w-full bg-bg-main py-16 md:py-24 px-4" data-id="element-77">
      <div className="max-w-5xl mx-auto" data-id="element-78">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="font-serif text-3xl md:text-4xl text-center text-text-primary mb-8" data-id="element-79">
          ¿Cuánto vale entenderte a ti misma?
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-80">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="flex justify-center" data-id="element-81">
            <img src="https://cdn.magicpatterns.com/uploads/oBf9CxMtrJgFHczKmntrb1/ChatGPT_Image_18_abr_2026,_11_02_06.png" alt="Guía Ciclo Consciente" className="w-full max-w-sm drop-shadow-2xl" data-id="element-82" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="space-y-6" data-id="element-83">
            <div className="text-center md:text-left" data-id="element-84">
              <p className="text-text-secondary line-through text-xl mb-2" data-id="element-85">
                $20 USD
              </p>
              <p className="font-serif text-5xl md:text-6xl text-accent mb-4" data-id="element-86">
                Solo $5 USD
              </p>
              <p className="text-lg text-text-secondary" data-id="element-87">
                Menos de lo que gastas en un café. Pero con un impacto que
                sentirás cada semana.
              </p>
            </div>

            <div className="space-y-3" data-id="element-88">
              <div className="flex items-center gap-3" data-id="element-89">
                <Download className="w-5 h-5 text-primary" data-id="element-90" />
                <span className="text-text-primary" data-id="element-91">Descarga inmediata</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-92">
                <Infinity className="w-5 h-5 text-primary" data-id="element-93" />
                <span className="text-text-primary" data-id="element-94">Acceso de por vida</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-95">
                <Clock className="w-5 h-5 text-primary" data-id="element-96" />
                <span className="text-text-primary" data-id="element-97">Formato digital</span>
              </div>
            </div>

            <div className="space-y-3 pt-2" data-id="element-98">
              <a href="https://pay.hotmart.com/Q105446382N" target="_blank" rel="noopener noreferrer" onClick={() => {
              if (window.fbq) {
                window.fbq('track', 'AddToCart');
              }
            }} className="block w-full bg-primary text-white text-center px-8 py-5 rounded-full text-xl font-medium shadow-xl hover:bg-accent transition-colors" data-id="element-99">
                Descargar mi guía por $5
              </a>
              <p className="text-center text-sm text-text-secondary font-medium" data-id="element-100">
                Acceso inmediato después de tu compra
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}